/**
 * Todo API
 * @class leaflet.API
 * @memberof google
 */
export class API {
    static get osmAccessToken() {
        return this._osmAccessToken;
    }
    static set osmAccessToken(value) {
        this._osmAccessToken = value;
    }
}
/**
 * todo
 * @type {string}
 * @private
 */
API._osmAccessToken = '';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVBJLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xlYWZsZXQvQVBJLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFDSCxNQUFNLE9BQU8sR0FBRztJQUNaLE1BQU0sS0FBSyxjQUFjO1FBQ3JCLE9BQU8sSUFBSSxDQUFDLGVBQWUsQ0FBQTtJQUMvQixDQUFDO0lBRUQsTUFBTSxLQUFLLGNBQWMsQ0FBRSxLQUFhO1FBQ3BDLElBQUksQ0FBQyxlQUFlLEdBQUcsS0FBSyxDQUFBO0lBQ2hDLENBQUM7O0FBRUQ7Ozs7R0FJRztBQUNZLG1CQUFlLEdBQVcsRUFBRSxDQUFBIn0=